<template>

  <div class="user">

    <!--添加商家-->
    <div class="common-level-rail">
      <!-- <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/project/project/add'">添加项目</el-button> -->
    </div>
    
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="是否合作">
            <el-option label="全部" value=""></el-option>
            <el-option label="未合作" value="0"></el-option>
            <el-option label="已合作" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.type" placeholder="项目分类">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item,index) in typeArr" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.title" placeholder="请输入项目标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="title" label="项目标题" ></el-table-column>
            <el-table-column prop="user.nickName" label="用户昵称" width="120"></el-table-column>  
            <el-table-column prop="user.mobile" label="用户联系方式" width="120"></el-table-column>  
            <el-table-column prop="remark" label="用户留下备注" width="120"></el-table-column>  
            <el-table-column prop="isHz" label="是否合作" >
              <template slot-scope="scope" >
                <span v-if="scope.row.status == 1">已合作</span>
                <span v-if="scope.row.status == 0">未合作</span>

              </template>
            </el-table-column>
          
            
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
           
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import projectApi from '@/api/project.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        status:"",
        title:"",
        type:""
      },
      status: ['未审核','审核通过', '审核不通过'],
      typeArr:[],
    };
  },
  created() {
    this.formInline.title = this.$route.query.title;
    /*获取列表*/
    this.getTableList();
    //获取项目分类
    var self = this;
    projectApi.getProjectType({}, true)
        .then(data => {
          self.typeArr = data.data;
        })
        .catch(error => {});
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;

      projectApi.user(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          console.log(self.tableData)
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

  
    /*添加项目*/
    addClick() {
      this.$router.push('/plus/project/project/add');
    },

    /*编辑项目*/
    editClick(row) {
      let project_id = row.project_id;
      this.$router.push({
        path: '/plus/project/project/edit',
        query: {
          project_id: project_id
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          projectApi.deleteProject(
            {
              project_id: row.project_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    passClick(item){//通过审核
      var self = this;
      var Params = {
        project_id:item.project_id,
        status:1
      }
      projectApi.passCanel(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {
          
         
        });

    },
    async nopassClick(item){//不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');

      var Params = {
        project_id:item.project_id,
        status:2,
        reject_val:reject_val
      }
      projectApi.passCanel(Params, true)
        .then(data => {
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
    
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/project/project/user.vue